$(() => {
  const $wrapper = $('.wcag-share-wrapper');
  if (!$wrapper.length) return;

  const $shareBtn = $wrapper.find('#js-share-trigger');
  const $dropdown = $wrapper.find('#js-share-dropdown');
  const DROPDOWN_CLOSE_ANIMATION_MS = 160;
  let closeAnimationTimer = null;
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if ($shareBtn.length && $dropdown.length) {
    const clearCloseAnimationTimer = () => {
      if (!closeAnimationTimer) return;
      window.clearTimeout(closeAnimationTimer);
      closeAnimationTimer = null;
    };

    const openDropdown = () => {
      clearCloseAnimationTimer();
      $dropdown.removeClass('is-closing').addClass('show is-open');
    };

    const closeDropdown = () => {
      if (!$dropdown.hasClass('show')) return;
      clearCloseAnimationTimer();

      if (prefersReducedMotion()) {
        $dropdown.removeClass('show is-open is-closing');
        return;
      }

      $dropdown.removeClass('is-open').addClass('is-closing');
      closeAnimationTimer = window.setTimeout(() => {
        $dropdown.removeClass('show is-closing');
        closeAnimationTimer = null;
      }, DROPDOWN_CLOSE_ANIMATION_MS);
    };

    $shareBtn.on('click', (e) => {
      e.stopPropagation();
      if ($dropdown.hasClass('show') && !$dropdown.hasClass('is-closing')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    $(document)
      .off('click.wcagShare')
      .on('click.wcagShare', (e) => {
        if (!$(e.target).closest('.wcag-share-wrapper').length) {
          closeDropdown();
        }
      });
  }

  $wrapper
    .find('.js-share-popup')
    .off('click.wcagSharePopup')
    .on('click.wcagSharePopup', function handleSharePopupClick(e) {
      e.preventDefault();

      const url = $(this).attr('href');
      const width = 800;
      const height = 600;

      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      window.open(
        url,
        'shareWindow',
        `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${
          width
        },height=${height},top=${top},left=${left}`
      );
    });
});
